<template>
	<a v-if="person.profileHandle" :href="baseUrl + 'profile/' + person.profileHandle">{{ person.userDisplayName }}</a>
	<span v-else>{{ person.userDisplayName }}</span>
</template>

<script>
export default {
	name: 'Person',
	components: {},
	props: {
		person: Object,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
		};
	},
};
</script>

<style lang="scss">
</style>
